import {
  grey100, // "#f5f5f5"
  grey300, // "#e0e0e0"
  grey400, // "#bdbdbd"
  grey800, // "#424242"
  white, // "#ffffff"
  lightGreen900 // "#33691E"
} from 'material-ui/styles/colors';

const styles = {
  // Custom styles
  arrows: {
    width: 90,
    height: 90
  },

  arrowSize: {
    width: 64,
    height: 64
  },

  block: {
    maxWidth: '200',
    marginLeft: '1.6rem',
    fontWeight: '200'
  },

  bookingBody: {
    marginBottom: '7vh',
    paddingRight: '2rem',
    paddingLeft: '2rem',
    margin: 'auto 0'
  },

  card: {
    marginTop: '1rem',
    backgroundColor: 'white',
    borderRadius: '4px'
  },

  datePicker: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    color: grey800,
    fontSize: '1.6rem'
  },

  darkContainerTitle: {
    color: grey800,
    textAlign: 'center',
    fontWeight: '200',
    paddingTop: '2rem',
    paddingBottom: '2rem',
    fontSize: '2rem'
  },

  fontWeight: {
    fontWeight: '200'
  },

  filterContainerStyles: {
    border: '1px solid',
    borderColor: grey100,
    padding: '1rem'
  },

  filterSeperator: {
    width: '90%'
  },

  filterTitle: {
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontWeight: '100'
  },

  flexJustify: {
    display: 'flex',
    justifyContent: 'center'
  },

  headingThinFilter: {
    paddingLeft: '1.6rem',
    fontWeight: '200'
  },

  noWrap: {
    whiteSpace: 'no-wrap',
    display: 'inline-block'
  },

  paddingZero: {
    paddingRight: '0',
    paddingLeft: '0',
    minWidth: '75%',
    fontSize: '1.5rem',
    whiteSpace: 'no-wrap',
    overflow: 'hidden',
    alignSelf: 'center'
  },

  strikethrough: {
    fontWeight: '200',
    textDecoration: 'line-through',
    textDecorationColor: grey800
  },

  timeSlot: {
    display: 'block',
    width: `${100 / 6.99}%`
  },

  tripleShiftStrike: {
    fontWeight: '200',
    color: grey800,
    textDecoration: 'line-through',
    textDecorationColor: 'red'
  },

  whiteText: {
    fontWeight: '200',
    color: 'white'
  },

  // Mui custom styles

  CheckboxFilterMui: {
    marginRight: '1.6rem',
    fill: lightGreen900
  },

  FilterMui: {
    backgroundColor: white,
    padding: '7%'
  },

  IconButtonMui: {
    right: {
      float: 'right',
      marginLeft: '1.6rem'
    },
    left: {
      alignSelf: 'center',
      float: 'left',
      marginRight: '1.6rem'
    }
  },

  LabelFilterMui: {
    color: '#fafafa',
    fontWeight: '200',
    marginLeft: '1.6rem',
    marginBottom: 0
  },

  ListShiftsMui: {
    backgroundColor: white,
    padding: '0'
  },

  listItem: {
    border: `1px solid ${grey400}`,
    borderRadius: '4px',
    margin: '1% auto',
    width: '100%'
  },

  monthHeader: {
    fontSize: '2.5rem',
    marginTop: '3rem',
    height: '100%',
    textAlign: 'center'
  },

  RaisedBtnLrgMui: {
    width: 'auto',
    borderRadius: '4px',
    marginTop: '1rem'
  },

  ShiftsDarkMui: {
    marginTop: '6rem',
    backgroundColor: grey800
  },

  tierCheckbox: {
    maxWidth: '10rem',
    marginLeft: '1.6rem'
  },

  ToggleFilterMui: {
    marginBottom: 16,
    // MUI toggle has a bug... marginRight must be given a numeric value
    marginRight: 32
  },

  ToggleThumbOffMui: {
    backgroundColor: grey300
  },
  ToggleTrackOffMui: {
    backgroundColor: grey300
  },
  ToggleThumbOnMui: {
    backgroundColor: lightGreen900
  },
  ToggleTrackOnMui: {
    backgroundColor: grey300
  },

  UnderlineFilterMui: {
    borderColor: white
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/styles.js